

import { COMMON_WAIFUS, getCommonReviews } from '../../../constants.js';

export const IT_BASE = {
    hero: {
      title: "Waifu Briscola",
      tagline: "La Briscola come non l'hai mai vista: RPG, Waifu e AI.",
      ctaWeb: "Gioca su Web",
      ctaAndroid: "Scarica per Android",
      ctaIOS: "Scarica per iOS", // Added
      version: "Versione 2.3",
      badge: "✨ Nuova Modalità Dungeon"
    },
    stats: {
      downloads: "Download",
      downloadsValue: ["Non li conti!", "Server Pieni", "Un sacco!", "Over 9000", "Troppi da contare"],
      hands: "Mani Perse",
      handsValue: ["Troppe...", "Skill Issue", "Colpa del Lag", "Piango ancora", "Riprova sarai più fortunato"],
      rating: "Valutazione",
      ratingValue: ["Mia nonna approva", "11/10 - IGN", "Meglio della pizza", "GOTY 2026", "Capolavoro Assoluto"],
      waifus: "Waifu",
      waifusValue: ["Tutte per te", "Solo 2D > 3D", "Collezionale tutte!", "Waifu > Meta", "Il vero tesoro"]
    },
    features: {
      title: "Molto più di un gioco di carte",
      items: [
        { id: "classic", title: "Briscola Classica", description: "L'esperienza originale, perfetta e pulita.", icon: "🃏" },
        { id: "roguelike", title: "RPG Roguelike", description: "Scala la torre, ottieni poteri elementali e sconfiggi i boss.", icon: "⚔️" },
        { id: "ai", title: "AI Vivente", description: "Grazie a Google Gemini, le avversarie ti insultano o ti lodano in tempo reale.", icon: "🧠" },
        { id: "gacha", title: "Gacha System", description: "Usa le monete per sbloccare nuove skin e sfondi rari.", icon: "💎" },
         { id: "dungeon", title: "Dungeon Mode", description: "Affronta boss con regole folli. Una sconfitta ed è finita.", icon: "🏰" },
        { id: "puzzle", title: "Modalità Puzzle", description: "Risolvi scenari complessi con obiettivi specifici.", icon: "🧩" }
      ]
    },
    video: { title: "Gameplay Trailer" },
    waifus: {
      title: "Scegli la tua Compagna",
      subtitle: "Ogni personaggio ha una personalità unica, doppiaggio e stile di gioco.",
      characters: [
        { ...COMMON_WAIFUS[0], name: "Miu", role: "La Dolce", personality: "Dolce e solare, ama starti vicino." },
        { ...COMMON_WAIFUS[1], name: "Rei", role: "L'Analitica", personality: "Calcolatrice e fredda. Solo logica." },
        { ...COMMON_WAIFUS[2], name: "Akame", role: "La Tsundere", personality: "Competitiva e focosa. Odia perdere." },
        { ...COMMON_WAIFUS[3], name: "Lilith", role: "La Regina", personality: "L'oscura regina delle carte." },
        { ...COMMON_WAIFUS[4], name: "Mochi", role: "La Guida", personality: "La tua guida fidata... forse." }
      ]
    },
    reviews: {
      title: "Dicono di noi (purtroppo)",
      items: getCommonReviews('it')
    },
    social: {
        title: "Unisciti alla Community",
        subtitle: "Non perderti aggiornamenti, meme e novità sulle Waifu. Seguici ora!",
        discordText: "Entra nel magico mondo di Waifu Briscola! 🌟 Unisciti al server per news esclusive, fare domande ai dev e partecipare attivamente allo sviluppo. La tua voce conta!",
        discordButton: "Unisciti alla Magia"
    },
    ctaStrip: {
      title: "Pronto a scendere in campo?",
      subtitle: "Unisciti ad altri giocatori e inizia la tua avventura oggi.",
      button: "Inizia a Giocare Ora"
    },
    footer: { privacy: "Privacy", terms: "Termini", copyright: "© 2026 Waifu Briscola" },
    privacy: {
      title: "Privacy Policy di Waifu Briscola",
      lastUpdated: "Ultimo aggiornamento: 25 Maggio 2024",
      intro: "Questa Privacy Policy descrive come le tue informazioni vengono gestite quando utilizzi l'applicazione Waifu Briscola ('Servizio').",
      sections: [
        {
          title: "Informazioni che raccogliamo",
          intro: "Per migliorare la tua esperienza, utilizziamo servizi di terze parti che possono raccogliere informazioni:",
          items: [
            "Dati di utilizzo (PostHog): Raccogliamo dati di analisi anonimi o pseudonimi su come interagisci con il gioco. Questo include eventi come l'inizio di una partita, le carte giocate e i risultati finali. Questi dati ci aiutano a capire come viene utilizzato il gioco e come possiamo migliorarlo. Non raccogliamo informazioni di identificazione personale (PII) attraverso PostHog.",
            "Interazioni con l'IA (Google Gemini): I messaggi di chat che invii e le informazioni sullo stato del gioco (come le carte nella tua mano e sul tavolo) vengono inviati all'API di Google Gemini per generare le risposte e le mosse dell'IA. Queste interazioni sono soggette alla Privacy Policy di Google. Non inviamo alcuna informazione personale a Google oltre al contenuto delle tue interazioni di gioco.",
          ],
        },
        {
          title: "Come utilizziamo le tue informazioni",
          intro: "Utilizziamo le informazioni raccolte per:",
          items: [
            "Fornire, operare e mantenere il nostro Servizio.",
            "Migliorare, personalizzare ed espandere il nostro Servizio.",
            "Comprendere e analizzare come utilizzi il nostro Servizio.",
            "Prevenir abusi e garantire la sicurezza.",
          ],
        },
        {
          title: "Condivisione delle informazioni",
          body: "Non condividiamo le tue informazioni personali con nessuno, ad eccezione dei fornitori di servizi di terze parti (PostHog, Google) necessari per il funzionamento dell'applicazione, come descritto sopra.",
        },
        {
          title: "Sicurezza dei dati",
          body: "La sicurezza delle tue informazioni è importante per noi, ma ricorda che nessun metodo di trasmissione su Internet o metodo di archiviazione elettronica è sicuro al 100%.",
        },
        {
          title: "Modifiche a questa Privacy Policy",
          body: "Potremmo aggiornare la nostra Privacy Policy di volta in volta. Ti informeremo di eventuali modifiche pubblicando la nuova Privacy Policy su questa pagina.",
        },
        {
          title: "Contattaci",
          body: "Se hai domande su questa Privacy Policy, puoi contattare il referente Mauro Mazzocchetti.",
        },
      ],
    },
    consent: { text: "Usiamo cookie e dati analitici per migliorare il sito. Continuando accetti la nostra", ok: "Ho capito" },
    terms: {
      title: "Termini e Condizioni di Waifu Briscola",
      lastUpdated: "Ultimo aggiornamento: 25 Maggio 2024",
      contact: "Referente: Mauro Mazzocchetti",
      intro: "Benvenuto in Waifu Briscola! Questi termini e condizioni delineano le regole per l'utilizzo dell'applicazione Waifu Briscola ('Servizio').",
      sections: [
        {
          title: "Accettazione dei Termini",
          body: "Accedendo e utilizzando questo Servizio, accetti di essere vincolato da questi Termini. Se non sei d'accordo con qualsiasi parte dei termini, non puoi utilizzare il Servizio.",
        },
        {
          title: "Utilizzo del Servizio",
          body: "Accetti di non utilizzare il Servizio per scopi illegali o non autorizzati. Sei responsabile della tua condotta e di qualsiasi contenuto che fornisci durante l'utilizzo del Servizio, inclusi i messaggi di chat.",
        },
        {
          title: "Contenuti Generati dall'IA",
          intro: "Il Servizio utilizza modelli di intelligenza artificiale (Google Gemini) per generare risposte, commenti e mosse di gioco. Riconosci che:",
          items: [
            "I contenuti generati dall'IA sono prodotti da un modello e potrebbero non essere sempre accurati, appropriati o coerenti.",
            "Non siamo responsabili per i contenuti generati dall'IA.",
            "Le interazioni con l'IA sono pensate solo per scopi di intrattenimento.",
          ],
        },
        {
          title: "Limitazione di Responsabilità",
          body: "In nessun caso Mauro Mazzocchetti, né i suoi partner, saranno responsabili per eventuali danni indiretti, incidentali, speciali, consequenziali o punitivi, inclusi, senza limitazione, la perdita di profitti, dati, avviamento o altre perdite immateriali, derivanti da (i) il tuo accesso o utilizzo o incapacità di accedere o utilizzare il Servizio; (ii) qualsiasi contenuto ottenuto dal Servizio.",
        },
        {
          title: "Modifiche ai Termini",
          body: "Ci riserviamo il diritto, a nostra esclusiva discrezione, di modificare o sostituire questi Termini in qualsiasi momento. Ti informeremo di eventuali modifiche pubblicando i nuovi termini su questa pagina.",
        },
        {
          title: "Legge Applicabile",
          body: "Questi Termini saranno regolati e interpretati in conformità con le leggi italiane, senza riguardo alle sue disposizioni sul conflitto di leggi.",
        },
      ],
    }
};
